import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"

export function UiTopBgSlider(props) {
    return (
        <>
             <div className="sb-top-bg-slider">
                <UiRowContainer>
                    {props.children}
                </UiRowContainer>
             </div>
        </>
    )
}
export function UiInnerTopBgSlider(props) {
    return (
        <>
             <div className="sb-inner-top-bg-slider">
                    {props.children}
             </div>
        </>
    )
}
export function UiTopBgSliderLeftContent(props) {
    
    return (
        <>
             <div className="sb-top-bg-slider__slider-content">
                {props.children}
             </div>
        </>
    )
}

export function UiTopShopBgSlider(props) {
    return (
        <>
             <div className="sb-top-bg-slider sb-shop-bg-slider">
                <UiRowContainer>
                    {props.children}
                </UiRowContainer>
             </div>
        </>
    )
}


export function UiTopBgLearnSlider(props) {
    return (
        <>
             <div className={props.bgImage ? 'sb-top-knowledge-slider':'sb-top-bg-slider'} 
             style={ props.bgImage ?  {
                backgroundImage: `url(${props.bgImage})`
               } : {}}>
                <UiRowContainer>
                    {props.children}
                </UiRowContainer>
             </div>
        </>
    )
}
export function UiTopInnerBgLearnSlider(props) {
    return (
        <>
             <div className={props.bgImage ? 'sb-top-inner-knowledge-slider':'sb-top-bg-slider'} 
             style={ props.bgImage ?  {
                backgroundImage: `url(${props.bgImage})`
               } : {}}>
                <UiRowContainer>
                    {props.children}
                </UiRowContainer>
             </div>
        </>
    )
}

export function UiTopLoyaltyBgSlider(props) {
    return (
        <>
             <div className="sb-top-bg-slider sb-loyalty-bg-slider">
                <UiRowContainer>
                    {props.children}
                </UiRowContainer>
             </div>
        </>
    )
}

export function UiTopBgSliderInnerContent(props) {
    
    return (
        <>
             <div className="sb-top-bg-slider__inner-content">
                {props.children}
             </div>
        </>
    )
}

